import React from 'react'
import './gallery.css'
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

// import required modules
import { EffectCoverflow, Pagination } from "swiper";


export const  Gallery = () => {
   
    return (
        <>
           <div className='gallery'>
           <div className="heading"><h6>GALLERY</h6></div>
           <div className='car'>
           <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={false}
        slidesPerView={3}
        coverflowEffect={{
          rotate: 80,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
        <video width="320" height="240" controls>
           <source src="./videos/1.mp4" type='video/mp4'/>
           Your browser does not support the video tag
            </video>
        </SwiperSlide>
        <SwiperSlide>
        <video width="320" height="240" controls>
            <source src="./videos/1.mp4" type='video/mp4'/>
           Your browser does not support the video tag
            </video>
        </SwiperSlide>
        <SwiperSlide>
        <video width="320" height="240" controls>
            <source src="./videos/1.mp4" type='video/mp4'/>
           Your browser does not support the video tag
            </video>
        </SwiperSlide>
        </Swiper>
            </div>
          </div>
        </>
    )
  }